import { Transaction } from '@/types';
import { logger } from '@/utils/logger';

export interface TransactionsState {
  transactions: Transaction[];
  isLoading: boolean;
  error: string | null;
}

export type TransactionsAction =
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_ERROR'; payload: string | null }
  | { type: 'SET_TRANSACTIONS'; payload: Transaction[] }
  | { type: 'ADD_TRANSACTION'; payload: Transaction }
  | { type: 'UPDATE_TRANSACTION'; payload: { id: string; updates: Partial<Transaction> } }
  | { type: 'DELETE_TRANSACTION'; payload: string }
  | { type: 'CLEAR_TRANSACTIONS' };

export const initialState: TransactionsState = {
  transactions: [],
  isLoading: false,
  error: null,
};

export function transactionsReducer(
  state: TransactionsState,
  action: TransactionsAction
): TransactionsState {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload };

    case 'SET_ERROR':
      return { ...state, error: action.payload };

    case 'SET_TRANSACTIONS':
      return { 
        ...state, 
        transactions: action.payload,
        isLoading: false,
        error: null
      };

    case 'ADD_TRANSACTION':
      logger.debug('Adding transaction to state', { id: action.payload.id });
      return {
        ...state,
        transactions: [action.payload, ...state.transactions],
        error: null,
      };

    case 'UPDATE_TRANSACTION': {
      const updated = state.transactions.map(t =>
        t.id === action.payload.id ? { ...t, ...action.payload.updates } : t
      );
      logger.debug('Updated transaction in state', { id: action.payload.id });
      return { ...state, transactions: updated, error: null };
    }

    case 'DELETE_TRANSACTION': {
      const filtered = state.transactions.filter(t => t.id !== action.payload);
      logger.debug('Deleted transaction from state', { id: action.payload });
      return { ...state, transactions: filtered, error: null };
    }

    case 'CLEAR_TRANSACTIONS':
      return { ...state, transactions: [], error: null };

    default:
      return state;
  }
}
